import { useQuery } from '@tanstack/react-query';
import { User, UserRole } from 'src/admin/users/types';

export type CompanyUser = Omit<User, 'userRole'> & {
  /** The list includes the account background jobs run as, whose role is outside UserRole. */
  userRole: UserRole | 'BACKGROUND_JOB_USER';
  /** When they last signed in; null if not since sign-ins began being recorded. */
  lastLoginAt: string | null;
};

/** True for a real person, false for the background job account. */
export const isPerson = (user: CompanyUser): user is CompanyUser & { userRole: UserRole } =>
  user.userRole !== 'BACKGROUND_JOB_USER';

export const useCompanyUsers = (companyId: string | null) => {
  const { data, isLoading, isError } = useQuery<CompanyUser[]>({
    queryKey: ['admin', 'companies', companyId, 'users'],
    enabled: !!companyId,
  });

  return { users: data, isLoading, isError };
};
